"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.errors.stepsLoadFailed': 'Failed to load steps',
    'tutorial.errors.avatarsLoadFailed': 'Failed to load avatars',
    'tutorial.errors.companiesLoadFailed': 'Failed to load companies',
    'tutorial.errors.loadFailed': 'Failed to load tutorial',
};
